/* ============================================================
   Shopify-specific behaviors:
   - Variant picker (sync buttons to hidden select, update price)
   - Product gallery (thumbs swap main image)
   - Cart qty +/- buttons
   - Cart count badge refresh on add
   ============================================================ */

(function () {
  document.addEventListener('DOMContentLoaded', () => {

    /* ----------------------------------------------------------
       1. PRODUCT VARIANT PICKER
    ---------------------------------------------------------- */
    const productForm = document.getElementById('ProductForm');
    const variantSelect = document.getElementById('ProductSelect');

    if (productForm && variantSelect) {
      const optionGroups = Array.from(productForm.querySelectorAll('[data-option-position]'));

      // Ogni <option> porta i valori della variante (data-options) e la sua foto (data-image)
      const variants = Array.from(variantSelect.options).map(opt => {
        let values;
        try { values = JSON.parse(opt.dataset.options || '[]'); } catch (e) { values = []; }
        if (!values.length) values = opt.textContent.trim().split(' / ');
        return { opt, values, available: opt.dataset.available === 'true' };
      });

      const initial = variants.find(v => v.opt.selected) || variants[0];
      let currentSelection = initial ? [...initial.values] : [];

      const findVariant = sel => variants.find(v => v.values.every((val, i) => val === sel[i]));

      // Una combinazione è acquistabile se esiste una variante disponibile con quel valore
      // e con le altre opzioni uguali alla selezione corrente
      const isValueAvailable = (pos, value) => variants.some(v =>
        v.available && v.values[pos] === value &&
        v.values.every((val, i) => i === pos || val === currentSelection[i])
      );

      optionGroups.forEach(group => {
        const pos = parseInt(group.dataset.optionPosition, 10);

        group.querySelectorAll('[data-value]').forEach(btn => {
          btn.addEventListener('click', () => {
            if (btn.disabled) return;

            const sel = [...currentSelection];
            sel[pos] = btn.dataset.value;
            let match = findVariant(sel);

            // Combinazione inesistente o esaurita: passa alla prima variante disponibile con il valore scelto
            if (!match || !match.available) {
              const candidates = variants.filter(v => v.values[pos] === btn.dataset.value);
              match = candidates.find(v => v.available) || match || candidates[0];
            }
            if (!match) return;

            currentSelection = [...match.values];
            render(match, true);
          });
        });
      });

      function render(variant, userAction) {
        variantSelect.value = variant.opt.value;

        optionGroups.forEach(group => {
          const pos = parseInt(group.dataset.optionPosition, 10);
          group.querySelectorAll('[data-value]').forEach(btn => {
            const value = btn.dataset.value;
            btn.classList.toggle('active', value === currentSelection[pos]);
            const available = isValueAvailable(pos, value);
            if (btn.classList.contains('size-option')) {
              // Taglie esaurite per il colore scelto: non cliccabili
              btn.classList.toggle('disabled', !available);
              btn.disabled = !available;
              btn.setAttribute('aria-disabled', String(!available));
            } else {
              // Colori e altre opzioni restano cliccabili, ma segnalati se esauriti
              btn.classList.toggle('is-unavailable', !available);
            }
          });
          const labelSpan = productForm.querySelector(`[data-selected-option="${pos}"]`);
          if (labelSpan) labelSpan.textContent = currentSelection[pos];
        });

        const opt = variant.opt;
        const priceEl = productForm.querySelector('[data-price]');
        const comparePriceEl = productForm.querySelector('[data-compare-price]');
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (comparePriceEl && opt.dataset.compareAtPrice) comparePriceEl.textContent = opt.dataset.compareAtPrice;

        const addBtn = productForm.querySelector('[data-add-cart]');
        const addTextEl = productForm.querySelector('[data-add-cart-text]');
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.setAttribute('aria-disabled', String(!variant.available));
        }
        if (addTextEl) {
          addTextEl.textContent = variant.available ? 'AGGIUNGI AL CARRELLO' : 'ESAURITO';
        }

        if (!userAction) return;

        // Foto della variante (es. colore) nella galleria
        if (opt.dataset.image) {
          const mainImg =
            document.getElementById('GalleryMainImage') ||
            document.querySelector('[data-gallery-main] img');
          if (mainImg && mainImg.getAttribute('src') !== opt.dataset.image) {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = opt.dataset.image;
          }
          document.querySelectorAll('[data-thumb]').forEach(t => {
            t.classList.toggle('active', t.dataset.imageId === opt.dataset.imageId);
          });
        }

        // URL condivisibile con la variante scelta
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', opt.value);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* noop */ }
      }

      if (initial) render(initial, false);
    }

    /* ----------------------------------------------------------
       2. PRODUCT GALLERY — thumbs swap main image
    ---------------------------------------------------------- */
    const galleryMainImg =
      document.getElementById('GalleryMainImage') ||
      document.querySelector('[data-gallery-main] img');
    const thumbs = document.querySelectorAll('[data-thumb]');

    // Preload all gallery images on idle so thumb-clicks are instant.
    const preload = () => thumbs.forEach(t => {
      if (!t.dataset.full) return;
      const img = new Image();
      img.decoding = 'async';
      img.src = t.dataset.full;
    });
    if ('requestIdleCallback' in window) requestIdleCallback(preload, { timeout: 2000 });
    else setTimeout(preload, 400);

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (galleryMainImg && thumb.dataset.full) {
          galleryMainImg.removeAttribute('srcset');
          galleryMainImg.removeAttribute('sizes');
          galleryMainImg.src = thumb.dataset.full;
        }
      });
    });

    /* ----------------------------------------------------------
       3. CART — qty +/- buttons (submit form on change)
    ---------------------------------------------------------- */
    document.querySelectorAll('[data-qty-minus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.nextElementSibling;
        if (input && input.type === 'number') {
          const v = Math.max(0, parseInt(input.value || '1', 10) - 1);
          input.value = v;
          input.form && input.form.submit();
        }
      });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.previousElementSibling;
        if (input && input.type === 'number') {
          input.value = parseInt(input.value || '0', 10) + 1;
          input.form && input.form.submit();
        }
      });
    });

    /* ----------------------------------------------------------
       4. ADD TO CART — AJAX con refresh del badge carrello
    ---------------------------------------------------------- */
    const atcForm = document.querySelector('form[action$="/cart/add"], form[action*="/cart/add"]');
    if (atcForm) {
      atcForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const btn = atcForm.querySelector('[data-add-cart]');
        const textEl = atcForm.querySelector('[data-add-cart-text]');
        const originalText = textEl ? textEl.textContent : '';

        if (btn) btn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(atcForm)
          });

          if (!res.ok) throw new Error('Add to cart failed');

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();

          document.querySelectorAll('.header__cart-count').forEach(badge => {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });

          renderCartDrawer(cart);
          openCartDrawer({ added: true });

          if (textEl) {
            textEl.textContent = 'AGGIUNTO ✓';
            setTimeout(() => { textEl.textContent = originalText; }, 1500);
          }
        } catch (err) {
          if (window.showToast) window.showToast('Errore. Riprova.');
          console.error(err);
        } finally {
          if (btn) btn.disabled = false;
        }
      });
    }

    /* v2 — cart drawer */
    /* ----------------------------------------------------------
       5. CART DRAWER — populate & open/close
    ---------------------------------------------------------- */
    const cartDrawer = document.getElementById('CartDrawer');

    function formatMoney(cents) {
      return '€' + (cents / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function renderCartDrawer(cart) {
      if (!cartDrawer) return;
      const itemsEl = cartDrawer.querySelector('[data-cart-items]');
      const totalEl = cartDrawer.querySelector('[data-cart-total]');
      const footerEl = cartDrawer.querySelector('.cart-drawer__footer');
      if (!itemsEl) return;

      const isEmpty = !cart.items || cart.items.length === 0;
      cartDrawer.classList.toggle('cart-drawer--empty', isEmpty);
      if (footerEl) footerEl.style.display = isEmpty ? 'none' : '';

      if (isEmpty) {
        itemsEl.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<svg class="cart-drawer__empty-icon" viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
            '<p class="cart-drawer__empty-title">Il tuo carrello è vuoto</p>' +
            '<p class="cart-drawer__empty-text">Lasciati ispirare dai nuovi arrivi della collezione.</p>' +
            '<a href="/collections/nuovi-arrivi" class="cart-drawer__empty-cta">Vai ai nuovi arrivi</a>' +
          '</div>';
      } else {
        itemsEl.innerHTML = cart.items.map(item => {
          const img = item.image
            ? '<img class="cart-drawer__item-image" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy">'
            : '<div class="cart-drawer__item-image"></div>';
          const variant = item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="cart-drawer__item-variant">' + item.variant_title + '</div>'
            : '';
          const safeTitle = item.product_title.replace(/"/g, '&quot;');
          return (
            '<div class="cart-drawer__item">' +
              img +
              '<div class="cart-drawer__item-meta">' +
                '<div class="cart-drawer__item-name">' + item.product_title + '</div>' +
                variant +
                '<div class="cart-drawer__item-bottom">' +
                  '<div class="cart-drawer__qty" role="group" aria-label="Quantità">' +
                    '<button type="button" class="cart-drawer__qty-btn" data-cart-qty="-1" data-cart-key="' + item.key + '" aria-label="Diminuisci">−</button>' +
                    '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
                    '<button type="button" class="cart-drawer__qty-btn" data-cart-qty="1" data-cart-key="' + item.key + '" aria-label="Aumenta">+</button>' +
                  '</div>' +
                  '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
                '</div>' +
              '</div>' +
              '<button type="button" class="cart-drawer__item-remove" data-cart-remove="' + item.key + '" aria-label="Rimuovi ' + safeTitle + '">' +
                '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg>' +
              '</button>' +
            '</div>'
          );
        }).join('');
      }
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    }

    async function postCartChange(payload, triggerEl) {
      if (triggerEl) {
        triggerEl.disabled = true;
        triggerEl.style.opacity = '0.4';
      }
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!res.ok) throw new Error('Cart change failed');
        const cart = await res.json();
        renderCartDrawer(cart);
        document.querySelectorAll('.header__cart-count').forEach(badge => {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      } catch (err) {
        console.error(err);
        if (triggerEl) {
          triggerEl.disabled = false;
          triggerEl.style.opacity = '';
        }
      }
    }

    async function removeCartItem(key, triggerEl) {
      return postCartChange({ id: key, quantity: 0 }, triggerEl);
    }

    function changeCartQty(key, delta, triggerEl) {
      const valueEl = triggerEl && triggerEl.parentElement
        ? triggerEl.parentElement.querySelector('.cart-drawer__qty-value')
        : null;
      const current = valueEl ? parseInt(valueEl.textContent, 10) || 0 : 0;
      const next = Math.max(0, current + delta);
      return postCartChange({ id: key, quantity: next }, triggerEl);
    }

    function openCartDrawer(opts) {
      if (!cartDrawer) return;
      const added = !!(opts && opts.added);
      cartDrawer.classList.toggle('cart-drawer--added', added);
      const titleText = cartDrawer.querySelector('[data-cart-drawer-title-text]');
      if (titleText) titleText.textContent = added ? 'Aggiunto al carrello' : 'Il tuo carrello';
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      const panel = cartDrawer.querySelector('.cart-drawer__panel');
      if (panel) setTimeout(() => panel.focus(), 320);
    }

    function closeCartDrawer() {
      if (!cartDrawer) return;
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }

    if (cartDrawer) {
      cartDrawer.querySelectorAll('[data-cart-close]').forEach(el => {
        el.addEventListener('click', closeCartDrawer);
      });
      cartDrawer.addEventListener('click', (e) => {
        const rm = e.target.closest('[data-cart-remove]');
        if (rm) {
          e.preventDefault();
          removeCartItem(rm.dataset.cartRemove, rm);
          return;
        }
        const qty = e.target.closest('[data-cart-qty]');
        if (qty) {
          e.preventDefault();
          changeCartQty(qty.dataset.cartKey, parseInt(qty.dataset.cartQty, 10), qty);
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && cartDrawer.getAttribute('aria-hidden') === 'false') closeCartDrawer();
      });
    }

    // Cart icon (header) — open drawer instead of navigating to /cart
    document.querySelectorAll('[data-cart-open]').forEach(el => {
      el.addEventListener('click', async (e) => {
        if (!cartDrawer) return; // let the link work as a fallback
        e.preventDefault();
        try {
          const cart = await fetch('/cart.js').then(r => r.json());
          renderCartDrawer(cart);
        } catch (err) {
          renderCartDrawer({ items: [], total_price: 0 });
        }
        openCartDrawer();
      });
    });
  });
})();
